import { useRef, useState, useEffect } from "react";
import styles from "./AddProject.module.css";
import TextInput from "../../Components/TextInput/InputText";
import { connect, useDispatch } from "react-redux";
import { createProject, fetchpropertyStage, fetchpropertyType } from "../../Services/contacts";
import Loading from "../../Components/Loading/Loading";
import { showSnackbarAction } from "../../Redux/actions";
import { themeColors } from "../../Components/theme";
import "../../theme-vars.css";
import { useTheme, useMediaQuery, Box, Grid } from "@mui/material";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";
import DropDownText from "../../Components/DropDownText/DropDownText";
import { fetchALLOrganizationMasterData } from "../../Services/organizations";

// Convert propertyStatus to label/value format
const propertyStatus = [
  { label: "Launched", value: "Launched" },
  { label: "Pre Launch", value: "Pre Launch" },
  { label: "Intermediate Occupation", value: "Intermediate Occupation" }
];

const AddProjectSuperAdmin = ({ history, user, theme, projectHeader }: any) => {
  const dispatcher = useDispatch();
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const projectNameRef: any = useRef();
  const developerNameRef: any = useRef();
  const reraLinkRef: any = useRef();
  const locationRef: any = useRef();
  const walkthroughLinkRef: any = useRef();
  const addressRef: any = useRef();
  const budgetRef: any = useRef();
  const [propertyStageSelected, setPropertyStageSelected] = useState<any>({ label: "Select", value: "Select" });
  const [projectStatusSelected, setProjectStatusSelected] = useState<any>({ label: "Select", value: "Select" });
  const [propertyStages, setPropertyStages] = useState<{ label: string; value: string }[]>([]);
  const [propertySubTypeSelected, setPropertySubTypeSelected] = useState<any>({ label: "Select", value: "Select" });
  const [propertySubTypes, setPropertySubTypes] = useState<string[]>([]);
  const [propertyTypeSelected, setPropertyTypeSelected] = useState<any>({ label: "Select", value: "Select" });
  const [propertyTypes, setPropertyTypes] = useState<{ label: string; value: string }[]>([]);
  const [OrgData, setOrgData] = useState<any[] | undefined>(undefined);
  const [seletedOrg, setSeletedOrg] = useState<any>({ label: "Select", value: "Select" });
  const [load, setLoad] = useState(false);

  useEffect(() => {
    let data = ["Office", "Mypod", "Vila", "Dupex", "Flat"];
    setPropertySubTypes(data);
  }, []);

  useEffect(() => {
    fetchALLOrganizationMasterData((val) => setOrgData(val));
  }, []);

  useEffect(() => {
    // fetchNewPropertySubType
    const unNewPropertyType = fetchpropertyType(
      seletedOrg.value,
      (data) => {
        // Ensure propertyTypes is an array of { label, value }
        const formatted = Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : [];
        setPropertyTypes(formatted);
      }
    );
    return () => {
      unNewPropertyType();
    };
  }, [seletedOrg.value]);

  useEffect(() => {
    // fetchNewPropertySubType
    const getPropertyState = fetchpropertyStage(
      seletedOrg.value,
      (data) => {
        // Ensure propertyTypes is an array of { label, value }
        const formatted = Array.isArray(data)
          ? data.map((item: any) =>
            typeof item === "string"
              ? { label: item, value: item }
              : item
          )
          : [];
        setPropertyStages(formatted);
      }
    );
    return () => {
      getPropertyState();
    };
  }, [seletedOrg.value]);

  useEffect(() => {
    window.onbeforeunload = function () {
      return "Are you really want to perform the action?";
    };
  }, []);

  const handlePropertyType = (e: any) => {
    const selectedValue = e.target.value;
    const selectedObj = propertyTypes.find((item: any) => item.value === selectedValue) || { label: "Select", value: "Select" };
    setPropertyTypeSelected(selectedObj);
  };

  const handlePropertyStage = (e: any) => {
    const selectedValue = e.target.value;
    const selectedObj = propertyStages.find((item: any) => item.value === selectedValue) || { label: "Select", value: "Select" };
    setPropertyStageSelected(selectedObj);
  };

  const handlePropertyStatus = (e: any) => {
    const selectedValue = e.target.value;
    const selectedObj = propertyStatus.find((item: any) => item.value === selectedValue) || { label: "Select", value: "Select" };
    setProjectStatusSelected(selectedObj);
  }

  const checkProject = () => {
    if(seletedOrg.value ==="Select"){
      dispatcher(showSnackbarAction("Please Select Organization", "error"));
      return false;
    }
    else if (developerNameRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Developer Name", "error"));
      return false;
    }
    else if (projectNameRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Project Name", "error"));
      return false;
    }
    else if (walkthroughLinkRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Walkthrough Link", "error"));
      return false;
    }
    else if (addressRef.current.value === "") {
      dispatcher(showSnackbarAction("Please Enter Address", "error"));
      return false;
    }
    else if (
      propertyTypeSelected.label === "Select" ||
      propertyTypeSelected.label === ""
    ) {
      dispatcher(showSnackbarAction("Please Enter Property Type", "error"));
      return false;
    }
    else if (
      propertyStageSelected.label === "Select" ||
      propertyStageSelected.label === ""
    ) {
      dispatcher(showSnackbarAction("Please Enter Property Stage", "error"));
      return false;
    }
    else if (
      projectStatusSelected.label === "Select" ||
      projectStatusSelected.label === ""
    ) {
      dispatcher(showSnackbarAction("Please Enter Project Status", "error"));
      return false;
    }
    else {
      return true;
    }
  };

  const create = (e: any) => {
    e.preventDefault();
    setLoad(true);
    let check = false;
    check = checkProject();
    if (check === true) {
      createProject(
        seletedOrg.value,
        projectNameRef.current.value,
        developerNameRef.current.value,
        addressRef.current.value,
        reraLinkRef.current.value,
        propertyStageSelected.label,
        projectStatusSelected.label,
        walkthroughLinkRef.current.value,
        propertyTypeSelected.label,
        user.user_first_name + " " + user.user_last_name,
        dispatcher,
        history,
        (data: boolean) => setLoad(data)
      )

    } else {
      setLoad(false);
    }
  };

  
  const choiceOrg = () => {
    if (!Array.isArray(OrgData) || OrgData.length === 0) {
      return [];
    }
    return OrgData.map((list: { organization_name?: string; org_id?: string }) => ({
      value: list?.org_id ?? "",
      label: list?.organization_name ?? "",
    }));
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  return (
    <div className={styles.parent} style={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
      {load === true && <Loading />}
      {isMobile && (
        <div className="d-flex flex-row w-100 px-4 pt-2">
          <h5 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>Add Project Details</h5>
        </div>
      )}
      <div
        className="w-100 d-flex flex-column gap-2 px-4"
        style={{
          padding: isMobile ? '0' : '',
          maxWidth: isMobile ? '100vw' : undefined,
          margin: isMobile ? '0' : '0 auto',
          overflowY: isMobile ? 'auto' : undefined,
          maxHeight: isMobile ? 'calc(100vh - 120px)' : undefined,
        }}
      >
        <form
          className={`card shadow rounded mt-2${!isMobile ? ` ${styles.forcePadding}` : ""}`}
          style={{
            ...cardContainerStyles,
            padding: isMobile ? '16px' : '32px',
            boxSizing: 'border-box',
            minHeight: isMobile ? 'auto' : undefined,
            marginBottom: isMobile ? '50px' : 0,
          }}
        >
          <Grid container spacing={isMobile ? 2 : 3}>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title="Organization (Select one)"
                options={choiceOrg()}
                value={seletedOrg?.value === "Select" ? "" : seletedOrg?.value}
                onChange={(e: any) => setSeletedOrg({ value: e.target.value, label: e.target.value })}
                required
                labelKey="label"
                valueKey="value"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="Developer Name"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={developerNameRef}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="Project Name"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={projectNameRef}
                required={true}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title="Property Type"
                options={propertyTypes}
                value={propertyTypeSelected.value === "Select" ? "" : propertyTypeSelected.value}
                onChange={handlePropertyType}
                required
                labelKey="label"
                valueKey="value"
                disabled={seletedOrg?.value === "Select"}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="Address"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={addressRef}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="Rera Link"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={reraLinkRef}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextInput
                title="Walkthrough Link"
                style={{ backgroundColor: "#fff", width: '100%' }}
                ref={walkthroughLinkRef}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title="Property Stage"
                options={propertyStages}
                value={propertyStageSelected.value === "Select" ? "" : propertyStageSelected.value}
                onChange={handlePropertyStage}
                required
                labelKey="label"
                valueKey="value"
                disabled={seletedOrg?.value === "Select"}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DropDownText
                title="Property Status"
                options={propertyStatus}
                value={projectStatusSelected.value === "Select" ? "" : projectStatusSelected.value}
                onChange={handlePropertyStatus}
                required
                labelKey="label"
                valueKey="value"
                disabled={seletedOrg?.value === "Select"}
              />
            </Grid>
            {/* Remove submit button from inside form for mobile */}
            {!isMobile && (
              <Grid item xs={12} style={{ marginTop: 12 }}>
                <StyledSubmitButton
                  onClick={create}
                  themeMode={themeMUI.palette.mode}
                >
                  {load ? (
                    <span style={{ display: "flex", justifyContent: "center" }}>
                      <Circles color="#fff" height={20} width={20} />
                    </span>
                  ) : (
                    <>Submit</>
                  )}
                </StyledSubmitButton>
              </Grid>
            )}
          </Grid>
        </form>
      </div>
      {isMobile && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            bgcolor: "white",
            p: 2,
            borderTop: "1px solid #ddd",
            boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
            zIndex: 100,
          }}
        >
          <StyledSubmitButton
            onClick={create}
            themeMode={themeMUI.palette.mode}
            isMobile={isMobile}
          >
            {load ? (
              <span style={{ display: "flex", justifyContent: "center" }}>
                <Circles color="#fff" height={20} width={20} />
              </span>
            ) : (
              <>Submit</>
            )}
          </StyledSubmitButton>
        </Box>
      )}
    </div>

  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    projectHeader: state.projectHeaderList.data,
  };
};

export default connect(mapStateToProps)(AddProjectSuperAdmin);
